import { useReducer, useRef,useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import { getUserDetails } from "../components/sidebar/Sidenav";
import { getAPIUrl, notify, ValidateInputField } from "../components/common/helpers";
import { getAuthToken } from "../api/api";
import Tooltip from "../components/common/ToolTip";
import { ReactComponent as Close } from "../../src/icons-svg/icons/close.svg";
import axios from "axios";
import "../styles/Modal.css";
import CreatableSelect from "react-select/creatable";
import { DraggableModalDialog } from "../components/common/DraggableModal"

const Site = (props) => {
  const { disabledFeatures, getSiteDetails, isEdit, setEdit, rowEntries } = props;
  const inputRef = useRef(null);

  const controller = new AbortController();
  const [customerEmail, setCustomerEmail] = useState("");
const [fieldTeamEmail, setFieldTeamEmail] = useState("");

const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
const [showFieldDropdown, setShowFieldDropdown] = useState(false);
  const formReducer = (state, action) => {
    switch (action.type) {
      case "SET_FIELD_VALUE":
        return {
          ...state,
          formData: {
            ...state.formData,
            [action.field]: action.value,
          },
        };

      case "SET_FORM_ERRORS":
        return {
          ...state,
          formErrors: {
            ...state.formErrors,
            [action.field]: action.error,
          },
        };
      case "SET_OPTION":
        return {
          ...state,
          options: action.options,
        };
      case "SET_NETWORKDIAGRAM_NAME":
        return {
          ...state,
          network_diagram_name: action.network_diagram_name,
        };
      case "SET_VALIDATED":
        return {
          ...state,
          validated: action.validated,
        };
      case "SET_SHOW":
        return {
          ...state,
          show: action.show,
        };
      case "RESET_FORM":
        return initialState;
      case "SET_CUSTOMER_DOMAIN_SUGGESTIONS":
        return {
          ...state,
          customerLoading: action.loading,
          customerDomainSuggestions: action.customerDomainSuggestions,
        };
        case "SET_CUSTOMER_DOMAIN_LIST":
          return {
            ...state,
            customerDomainList: action.customerDomainList,
          };
      case "SET_FIELD_DOMAIN_SUGGESTIONS":
        return {
          ...state,
          fieldLoading: action.loading,
          fieldDomainSuggestions: action.fieldDomainSuggestions,
        };
        case "SET_FIELD_DOMAIN_LIST":
          return {
            ...state,
            fieldDomainList: action.fieldDomainList,
          };
      case "SET_CUSTOMER_EMAIL_PREFIX":
        return {
          ...state,
          customerEmailPrefix: action.customerEmailPrefix,
        };
      case "SET_FIELD_EMAIL_PREFIX":
        return {
          ...state,
          fieldEmailPrefix: action.fieldEmailPrefix,
        };
      case "SET_CUSTOMER_FETCHED_PREFIX":
        return {
          ...state,
          customerFetchedPrefix: action.customerFetchedPrefix,
        };
      case "SET_FIELD_FETCHED_PREFIX":
        return {
          ...state,
          fieldFetchedPrefix: action.fieldFetchedPrefix,
        };
      default:
        return state;
    }
  };

  const initialState = {
    formData: {
      site_name: isEdit ? rowEntries.building_name : "",
      customer_name: isEdit ? rowEntries.customer_name : "",
      site_address: isEdit ? rowEntries.building_address : "",
      site_state: isEdit ? rowEntries.building_state : "",
      site_city: isEdit ? rowEntries.bulding_city : "",
      site_id: isEdit ? rowEntries.site_id : "",
      network_diagram: null,
      customer_email_id: isEdit
        ? rowEntries.customer_email_id
          ?.split(",")
          .map(email => ({
            label: email.trim(),
            value: email.trim()
          }))
        : [],
      field_team_email_id: isEdit
        ? rowEntries.field_team_email_id
          ?.split(",")
          .map(email => ({
            label: email.trim(),
            value: email.trim()
          }))
        : [],

    },
    customerDomainSuggestions: [],
    fieldDomainSuggestions: [],
    customerEmailPrefix: "",
    customerFetchedPrefix: "",
    fieldEmailPrefix: "",
    fieldFetchedPrefix: "",
      customerDomainList: [],
      fieldDomainList: [],
      customerLoading: false,
      fieldLoading: false,

    formErrors: {
      site_name: "",
      customer_name: "",
      customer_email_id: "",
      field_team_email_id: "",
      site_address: "",
      site_state: "",
      site_city: "",
      component_type: "",
      network_diagram: ""
    },
    network_diagram_name: isEdit ? rowEntries.network_diagram_path : null,
    validated: false,
    show: false,
    rowdata: {},
    options: [],
  };

  const [state, dispatch] = useReducer(formReducer, initialState);
  const { formData, formErrors, validated, show, network_diagram_name } = state;

  const isEditChecker = () => {
    return isEdit && isEdit !== null
  }

  const handleClose = () => {
    if (controller) {
      controller.abort();
    }
    dispatch({ type: "SET_SHOW", show: false });
    dispatch({ type: "RESET_FORM" });
    isEdit && setEdit(false);
  };
  const handleShow = () => dispatch({ type: "SET_SHOW", show: true });

  const defaultValidation = () => {
    return Object.values(formErrors).every((error) => error === "valid" || error === "") &&
      formData.site_name &&
      formData.customer_name &&
      formData.site_address &&
      formData.site_state &&
      formData.customer_email_id &&
      formData.field_team_email_id
  }

  const isFormValid = () => {
    if (isEdit) {
      return defaultValidation() && ((JSON.stringify(formData) !== JSON.stringify(initialState["formData"]))
      )
    } else {
      return defaultValidation()
        && formData.network_diagram;
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type } = event.target;
    if (name === "network_diagram" && type === "file" && isEdit) {
      dispatch({
        type: "SET_NETWORKDIAGRAM_NAME",
        network_diagram_name: null,
      })
    }
    const error = ValidateInputField(name, value);

    dispatch({ type: "SET_FIELD_VALUE", field: name, value });
    dispatch({ type: "SET_FORM_ERRORS", field: name, error });
  };

  const formatToUpperCase = (inputValue) => {
    return inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
  };

  const handleEmailChange = (name, value) => {
    dispatch({
      type: "SET_FIELD_VALUE",
      field: name,
      value,
    });

    dispatch({
      type: "SET_FORM_ERRORS",
      field: name,
      error: validateEmailArray(value),
    });
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const isValidEmail = (email) => emailRegex.test(email);

  const validateEmailArray = (emails = []) => {
    if (!emails.length) return "error";
    return emails.every(e => isValidEmail(e.value))
      ? "valid"
      : "error";
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form_Data = new FormData(event.target);

    isEditChecker() && form_Data.append("site_id", rowEntries.site_id);
    const userid = isEditChecker() ? "updated_by" : "created_by";


    const customerEmails = formData.customer_email_id
      .map(e => e.value)
      .join(",");

    const fieldTeamEmails = formData.field_team_email_id
      .map(e => e.value)
      .join(",");

    form_Data.set("customer_email_id", customerEmails);
    form_Data.set("field_team_email_id", fieldTeamEmails);
    form_Data.append(userid, getUserDetails().username);

    if (isEditChecker()) {
      try {
        axios({
          method: "PATCH",
          url: getAPIUrl("updateSiteDetails"),
          headers: {
            Authorization: getAuthToken(),
          },
          signal: controller.signal,
          data: form_Data,
        })
          .then((res) => {
            if (res && res.data.code === 200) {
              handleClose();
              alert("Site Details Updated Successfully");
              setTimeout(() => {
                getSiteDetails();
              }, 3000);
            }
          })
          .catch((error) => {
            error.message !== "canceled" && notify("updating");
          });
      } catch (error) {
        console.log("Error fetching data:" + error);
      }
    } else {
      try {
        axios({
          method: "POST",
          url: getAPIUrl("addSiteDetailsApi"),
          headers: {
            Authorization: getAuthToken(),
          },
          signal: controller.signal,
          data: form_Data,
        })
          .then((res) => {
            if (res && !res.data.code) {
              handleClose();
              alert("Site Details Added Successfully");
              setTimeout(() => {
                getSiteDetails();
              }, 3000);
            } else {
              alert("Site Already Exists");
            }
          })
          .catch((error) => {
            error.message !== "canceled" && notify("submission");
          });
      } catch (error) {
        console.log("Error fetching data:" + error);
      }
    }
    dispatch({ type: "SET_VALIDATED", validated: false });
  };

  const fetchDomainsApi = async (emailType, suggestionType, dispatchType) => {
    try {
      // set a loading placeholder so dropdown shows "Loading Domains..."
      dispatch({
        type: dispatchType,
        [suggestionType]: [{ label: "Loading Domains...", value: "__loading", isDisabled: true }],
        loading: true,
      });

      const response = await axios.get(
        getAPIUrl("getEmailDomainListApi"),
        {
          params: { email_type: emailType, is_added: 1 },
          headers: {
            Authorization: getAuthToken(),
          },
        }
      );

      const domainSuggestions = response.data.map((item) => ({
        id: item.domainId,
        domain: item.domainName,
      }));

      if (!domainSuggestions || domainSuggestions.length === 0) {
        dispatch({
          type: dispatchType,
          [suggestionType]: [{ label: "No domains found", value: "__none", isDisabled: true }],
          loading: false,
        });
      } else {
        dispatch({
          type: dispatchType,
          [suggestionType]: domainSuggestions.map((d) => ({ label: d.domain, value: d.domain })),
          loading: false,
        });
        // also store the full list for client-side filtering
        if (dispatchType === 'SET_CUSTOMER_DOMAIN_SUGGESTIONS') {
          dispatch({ type: 'SET_CUSTOMER_DOMAIN_LIST', customerDomainList: domainSuggestions.map(d => d.domain) });
        } else if (dispatchType === 'SET_FIELD_DOMAIN_SUGGESTIONS') {
          dispatch({ type: 'SET_FIELD_DOMAIN_LIST', fieldDomainList: domainSuggestions.map(d => d.domain) });
        }
      }
    } catch (error) {
      console.log("Error fetching domains:", error);
      dispatch({
        type: dispatchType,
        [suggestionType]: [{ label: "No domains found", value: "__none", isDisabled: true }],
        loading: false,
      });
      if (dispatchType === 'SET_CUSTOMER_DOMAIN_SUGGESTIONS') {
        dispatch({ type: 'SET_CUSTOMER_DOMAIN_LIST', customerDomainList: [] });
      } else if (dispatchType === 'SET_FIELD_DOMAIN_SUGGESTIONS') {
        dispatch({ type: 'SET_FIELD_DOMAIN_LIST', fieldDomainList: [] });
      }
    }
  };

  return (
    <>
      {" "}
      {!isEdit && (!disabledFeatures.includes("AddSite")) && (
        <Button
          size="sm"
          variant="secondary"
          style={{ background: "#ffffff", color: "#000000", width: "120px" }}
          onClick={handleShow}
        >
          +Add a Site
        </Button>
      )}
      <Modal
        show={show || isEdit}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        dialogAs={DraggableModalDialog}
      >
        <Modal.Header className="cancelButton">
          <Modal.Title style={{ color: "#ffffff" }}>
            <Row>
              <Col sm={{ span: 7 }}>
                <h3>{isEditChecker() ? "Edit Site Details" : "Add Site"}</h3>
              </Col>
              <Col sm={{ offset: 3 }}>
                <Button
                  className="col-md-8 hoverEffect"
                  size="sm"
                  variant="Dark"
                  onClick={handleClose}
                  aria-label="Close Button"
                >
                  <Close />
                </Button>
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#212529" }}>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group as={Row} md="12" className="formField">
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="site name"
                >
                  Site Name
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    ref={inputRef}
                    size="sm"
                    aria-required
                    type="text"
                    readOnly={isEdit}
                    placeholder="Site name"
                    name="site_name"
                    id="validationCustom01"
                    value={
                      formData.site_name !== ""
                        ? formatToUpperCase(formData.site_name)
                        : formData.site_name
                    }
                    onChange={handleInputChange}
                    aria-invalid={formErrors.site_name === "error"}
                    isInvalid={formErrors.site_name === "error"}
                    isValid={formErrors.site_name === "valid"}
                  />
                  {formErrors.site_name === "error" && (
                    <Tooltip type="sitename" specialCharException={"-, _"} required={true} />
                  )}
                </Col>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Row} md="12" className="formField">
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="customer name"
                >
                  Customer Name
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    size="sm"
                    aria-required
                    type="text"
                    placeholder="Customer name"
                    name="customer_name"
                    id="validationCustom02"
                    value={
                      formData.customer_name !== ""
                        ? formatToUpperCase(formData.customer_name)
                        : formData.customer_name
                    }
                    onChange={handleInputChange}
                    isInvalid={formErrors.customer_name === "error"}
                    isValid={formErrors.customer_name === "valid"}
                  />
                  {formErrors.customer_name === "error" && (
                    <Tooltip type="username" charLength={3} required={true} />
                  )}
                </Col>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Row} md="12" className="formField">
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="customer email id"
                >
                  Customer EmailId
                </Form.Label>
                <Col sm={8}>
                  <CreatableSelect
                    size="sm"
                    isMulti
                    components={{
                      DropdownIndicator: null,
                      IndicatorSeparator: null
                    }}
                    options={state.customerDomainSuggestions}
                    menuIsOpen={showCustomerDropdown && state.customerDomainSuggestions?.length > 0}
                    classNamePrefix="react-select"
                    required
                    placeholder="Type email and press Enter"
                    id="validationCustom02"
                    filterOption={null}
                    isValidNewOption={() => false}
                    name="customer_email_id"
                    value={formData.customer_email_id}
                    onInputChange={(inputValue) => {
                      if (inputValue.includes("@")) {
                        const atIndex = inputValue.indexOf("@");
                        const prefix = inputValue.slice(0, atIndex);
                        const afterAt = inputValue.slice(atIndex + 1);

                        dispatch({
                          type: "SET_CUSTOMER_EMAIL_PREFIX",
                          customerEmailPrefix: prefix,
                        });

                        // If prefix changed, fetch new domain list
                        if (prefix !== state.customerFetchedPrefix) {
                          dispatch({ type: "SET_CUSTOMER_FETCHED_PREFIX", customerFetchedPrefix: prefix });
                          setShowCustomerDropdown(true);
                          fetchDomainsApi(1, 'customerDomainSuggestions', 'SET_CUSTOMER_DOMAIN_SUGGESTIONS');
                        } else {
                          // prefix same as before — reuse cached list
                          const list = state.customerDomainList || [];
                          if (afterAt === "") {
                            const suggestions = list.length ? list.map(d => ({ label: d, value: d })) : [{ label: "No domains found", value: "__none", isDisabled: true }];
                            dispatch({ type: 'SET_CUSTOMER_DOMAIN_SUGGESTIONS', customerDomainSuggestions: suggestions, loading: false });
                            setShowCustomerDropdown(true);
                          } else {
                            const filtered = list.filter(d => d.toLowerCase().includes(afterAt.toLowerCase()));
                            const suggestions = filtered.length ? filtered.map(d => ({ label: d, value: d })) : [{ label: "No domains found", value: "__none", isDisabled: true }];
                            dispatch({ type: 'SET_CUSTOMER_DOMAIN_SUGGESTIONS', customerDomainSuggestions: suggestions, loading: false });
                            setShowCustomerDropdown(true);
                          }
                        }

                        return inputValue;
                      } else {
                        dispatch({ type: "SET_CUSTOMER_DOMAIN_SUGGESTIONS", customerDomainSuggestions: [], loading: false });
                        setShowCustomerDropdown(false);
                      }
                      return inputValue;
                    }}
                    

                    onChange={(value, actionMeta) => {
                      if (actionMeta.action === "select-option") {
                        const selectedDomain = actionMeta.option.value;

                        const fullEmail = `${state.customerEmailPrefix}@${selectedDomain}`;

                        const updated = [
                          ...formData.customer_email_id,
                          { label: fullEmail, value: fullEmail }
                        ];

                        handleEmailChange("customer_email_id", updated);
                        dispatch({
                          type: "SET_CUSTOMER_DOMAIN_SUGGESTIONS",
                          customerDomainSuggestions: [],
                          loading: false,
                        });
                        dispatch({
                          type: "SET_CUSTOMER_EMAIL_PREFIX",
                          customerEmailPrefix: "",
                        });
                        // close dropdown immediately after selection
                        setShowCustomerDropdown(false);
                      } else {
                        // If user removed/cleared previously added emails, reset fetched prefix
                        if (
                          actionMeta &&
                          (actionMeta.action === "remove-value" || actionMeta.action === "pop-value" || actionMeta.action === "clear")
                        ) {
                          dispatch({
                            type: "SET_CUSTOMER_FETCHED_PREFIX",
                            customerFetchedPrefix: "",
                          });
                        }

                        // If all values cleared, also reset fetched prefix
                        if (Array.isArray(value) && value.length === 0) {
                          dispatch({
                            type: "SET_CUSTOMER_FETCHED_PREFIX",
                            customerFetchedPrefix: "",
                          });
                        }

                        handleEmailChange("customer_email_id", value);
                      }
                    }}

                    className={
                      formErrors.customer_email_id === "error"
                        ? "react-select-container error"
                        : "react-select-container"
                    }
                  />
                  {formErrors.customer_email_id === "error" && (
                    <Tooltip type="customerid" required={true} />
                  )}
                  {(formErrors.customer_email_id !== "error" && formData.customer_email_id.length === 0) && ( 
                                        <Form.Text className="text-muted d-block mt-2">
                      <div style={{ fontSize: "0.875rem", marginTop: "0.5rem" }}>
                        <strong>Instructions: </strong>
                        Type "@" after the email name to see available domain options.
                      </div>
                                        </Form.Text>
                  )}           
                </Col>

              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Row} md="12" className="formField">
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="customer email id"
                >
                  Field Team EmailId
                </Form.Label>
                <Col sm={8}>
                  <CreatableSelect
                    isMulti
                    classNamePrefix="react-select"
                    size="sm"
                    required
                    placeholder="Type email and press Enter"
                    value={formData.field_team_email_id}
                    options={state.fieldDomainSuggestions}
                    menuIsOpen={showFieldDropdown && state.fieldDomainSuggestions?.length > 0}
                    filterOption={null}
                    isValidNewOption={() => false}
                    components={{
                      DropdownIndicator: null,
                      IndicatorSeparator: null
                    }}
                    onInputChange={(inputValue) => {
                      if (inputValue.includes("@")) {
                        const atIndex = inputValue.indexOf("@");
                        const prefix = inputValue.slice(0, atIndex);
                        const afterAt = inputValue.slice(atIndex + 1);

                        dispatch({ type: "SET_FIELD_EMAIL_PREFIX", fieldEmailPrefix: prefix });

                        if (prefix !== state.fieldFetchedPrefix) {
                          dispatch({ type: "SET_FIELD_FETCHED_PREFIX", fieldFetchedPrefix: prefix });
                          setShowFieldDropdown(true);
                          fetchDomainsApi(2, "fieldDomainSuggestions", "SET_FIELD_DOMAIN_SUGGESTIONS");
                        } else {
                          const list = state.fieldDomainList || [];
                          if (afterAt === "") {
                            const suggestions = list.length ? list.map(d => ({ label: d, value: d })) : [{ label: "No domains found", value: "__none", isDisabled: true }];
                            dispatch({ type: 'SET_FIELD_DOMAIN_SUGGESTIONS', fieldDomainSuggestions: suggestions, loading: false });
                            setShowFieldDropdown(true);
                          } else {
                            const filtered = list.filter(d => d.toLowerCase().includes(afterAt.toLowerCase()));
                            const suggestions = filtered.length ? filtered.map(d => ({ label: d, value: d })) : [{ label: "No domains found", value: "__none", isDisabled: true }];
                            dispatch({ type: 'SET_FIELD_DOMAIN_SUGGESTIONS', fieldDomainSuggestions: suggestions, loading: false });
                            setShowFieldDropdown(true);
                          }
                        }

                        return inputValue;
                      } else {
                        dispatch({ type: "SET_FIELD_DOMAIN_SUGGESTIONS", fieldDomainSuggestions: [] });
                        setShowFieldDropdown(false);
                      }
                      return inputValue;
                    }
                    }

                    onChange={(value, actionMeta) => {
                      if (actionMeta.action === "select-option") {
                        const selectedDomain = actionMeta.option.value;

                        const fullEmail = `${state.fieldEmailPrefix}@${selectedDomain}`;

                        const updated = [
                          ...formData.field_team_email_id,
                          { label: fullEmail, value: fullEmail }
                        ];

                        handleEmailChange("field_team_email_id", updated);
                        dispatch({
                          type: "SET_FIELD_DOMAIN_SUGGESTIONS",
                          fieldDomainSuggestions: [],
                        });
                        dispatch({
                          type: "SET_FIELD_EMAIL_PREFIX",
                          fieldEmailPrefix: "",
                        });
                        // close dropdown after selection
                        setShowFieldDropdown(false);
                      } else {
                        // reset fetched prefix when items are removed/cleared so same prefix will trigger fetch again
                        if (
                          actionMeta &&
                          (actionMeta.action === "remove-value" || actionMeta.action === "pop-value" || actionMeta.action === "clear")
                        ) {
                          dispatch({
                            type: "SET_FIELD_FETCHED_PREFIX",
                            fieldFetchedPrefix: "",
                          });
                        }

                        if (Array.isArray(value) && value.length === 0) {
                          dispatch({
                            type: "SET_FIELD_FETCHED_PREFIX",
                            fieldFetchedPrefix: "",
                          });
                        }

                        handleEmailChange("field_team_email_id", value);
                      }
                    }}
                    className={
                      formErrors.field_team_email_id === "error"
                        ? "react-select-container error"
                        : "react-select-container"
                    }
                  />
                  {formErrors.field_team_email_id === "error" && (
                    <Tooltip type="customerid" required={true} />
                  )}
                   {(formErrors.field_team_email_id !== "error" && formData.field_team_email_id.length === 0) && ( 
                                        <Form.Text className="text-muted d-block mt-2">
                      <div style={{ fontSize: "0.875rem", marginTop: "0.5rem" }}>
                        <strong>Instructions: </strong>
                        Type "@" after the email name to see available domain options.
                      </div>
                                        </Form.Text>
                  )}  
                </Col>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Row} md="12" className="formField">
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="site Address"
                >
                  Site Address
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    size="sm"
                    required
                    as="textarea"
                    placeholder="Site address"
                    name="site_address"
                    id="validationCustom03"
                    value={
                      formData.site_address !== ""
                        ? formatToUpperCase(formData.site_address)
                        : formData.site_address
                    }
                    onChange={handleInputChange}
                    isInvalid={formErrors.site_address === "error"}
                    isValid={formErrors.site_address === "valid"}
                  />
                  {formErrors.site_address === "error" && (
                    <Tooltip type="address" specialCharException={".,#"} required={true} />
                  )}
                </Col>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Row} md="12" className="formField">
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="country"
                >
                  Country
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    size="sm"
                    required
                    type="text"
                    placeholder="Country"
                    name="site_country"
                    id="validationCustom04"
                    value="USA"
                    readOnly
                  />
                </Col>
                <Col sm={12}>
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid site country.
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Row} md="12" className="formField">
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="state"
                >
                  State
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    size="sm"
                    required
                    type="text"
                    placeholder="State"
                    name="site_state"
                    id="validationCustom05"
                    value={formData.site_state}
                    onChange={handleInputChange}
                    isInvalid={formErrors.site_state === "error"}
                    isValid={formErrors.site_state === "valid"}
                  />
                  {formErrors.site_state === "error" && (
                    <Tooltip type="state" required={true} />
                  )}
                </Col>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Row} md="12" className="formField">
                <Form.Label style={{ color: "white" }} size="sm" column sm={4}
                  htmlFor="city">
                  City
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    size="sm"
                    required
                    type="text"
                    placeholder="City"
                    name="site_city"
                    id="validationCustom06"
                    onChange={handleInputChange}
                    value={formData.site_city}
                    isInvalid={formErrors.site_city === "error"}
                    isValid={formErrors.site_city === "valid"}
                  />
                  {formErrors.site_city === "error" && (
                    <Tooltip type="state" />
                  )}
                </Col>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group
                as={Row}
                md="12"
                className="formField"
              >
                <Form.Label
                  className={"required"}
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="upload network diagram"
                  aria-label="upload network diagram"
                >
                  Network Diagram
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    size="sm"
                    aria-required
                    type="file"
                    id="validationCustom07"
                    name="network_diagram"
                    onChange={handleInputChange}
                    aria-invalid={formErrors.network_diagram === "error"}
                    isInvalid={formErrors.network_diagram === "error"}
                    isValid={formErrors.network_diagram === "valid"}
                  />
                  {(isEdit && network_diagram_name !== null) && <Form.Text className="text-muted">{rowEntries.network_digram_path}</Form.Text>}
                  {formErrors.network_diagram === "error" && (
                    <Tooltip type="network_diagram" />
                  )}
                </Col>
              </Form.Group>
            </Row>
            <Row>
              <Col sm={{ span: 10, offset: 2 }}>
                <Button
                  className="col-md-5"
                  size="sm"
                  variant="secondary"
                  type="submit"
                  disabled={!isFormValid()}
                >
                  {isEditChecker() ? "Update" : "Submit"}
                </Button>
                {" "}
                <Button
                  className="col-md-5"
                  size="sm"
                  variant="secondary"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Site;